export default {"src":"/_next/static/image/public/images/flags/flag_268.06a0f9d268a8d92b6f783f18f127a332.svg","height":16,"width":24};